'use client';

import { Icon } from '@polyseme/design-system';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import Link from 'next/link';

import { images } from '~/landing/assets';
import { Button } from '~/landing/components/shared';

import { Badge } from '../components/badge';
import { Title } from '../components/title';
import { contactId, featuresId } from '../constants';

const products = ['lifeInsurance', 'per', 'pero'] as const;

export const HeroSection = () => {
  const t = useTranslations('landing.polyseme.hero');

  return (
    <section
      className="min-lg:h-[calc(100dvh-88px)] flex min-h-[calc(100dvh-56px)] w-full flex-col items-center justify-center text-center"
      id="hero"
    >
      <div className="container mx-auto flex max-w-6xl flex-col px-6 lg:-translate-y-12">
        <Title
          as="h1"
          className="mb-4 translate-y-6 whitespace-pre-wrap text-center sm:translate-y-32"
          variant="title-1"
        >
          {t('title')}
        </Title>

        <div className="flex flex-col gap-6">
          <div className="flex translate-y-6 flex-wrap justify-center gap-3 sm:translate-y-32">
            {products.map((product) => (
              <Badge key={product} size="lg" variant="neutral">
                {t(`products.${product}`)}
              </Badge>
            ))}
          </div>

          <div className="relative flex justify-center overflow-hidden bg-transparent">
            <div className="absolute bottom-0 h-3/5 w-full rounded-3xl bg-accent"></div>
            <Image
              alt=""
              className="relative z-10 block h-auto w-[90%] translate-y-6 sm:w-10/12 sm:translate-y-32"
              height={960}
              src={images.polyseme.hero}
              width={1440}
            />
          </div>

          <div className="flex flex-wrap justify-center gap-4">
            <Button asChild className="w-full sm:w-auto" size="xl">
              <Link href={`#${contactId}`}>
                {t('cta.primary')}
                <Icon name="circle-play" />
              </Link>
            </Button>
            <Button
              asChild
              className="w-full sm:w-auto"
              size="xl"
              variant="outline"
            >
              <Link href={`#${featuresId}`}>
                {t('cta.secondary')}
                <Icon name="corner-right-down" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
